import { inject, Injectable } from '@angular/core';
import { ApiResponseModel, ApiService } from '@solcre-org/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment.local';
import { PortOvertimeRuleModel } from '../models/port-overtime-rule.model';

@Injectable({
  providedIn: 'root',
})
export class PortOvertimeRuleService {
  private apiService: ApiService = inject(ApiService);

  public fetchByPort(portId: string): Observable<PortOvertimeRuleModel[]> {
    return this.apiService
      .fetchData(environment.API.PORT_OVERTIME_RULES_URI, { port: this.portIri(portId) })
      .pipe(map((response: ApiResponseModel) => new PortOvertimeRuleModel().fromJSONList(this.extractCollection(response.data))));
  }

  public create(payload: Partial<PortOvertimeRuleModel>): Observable<PortOvertimeRuleModel> {
    return this.apiService
      .createObj(environment.API.PORT_OVERTIME_RULES_URI, payload)
      .pipe(map((response: ApiResponseModel) => new PortOvertimeRuleModel().fromJSON(this.extractObject(response.data))));
  }

  public update(ruleId: string, payload: Partial<PortOvertimeRuleModel>): Observable<PortOvertimeRuleModel> {
    return this.apiService
      .partialUpdateObj(environment.API.PORT_OVERTIME_RULES_URI, ruleId, payload, false, {
        'Content-Type': 'application/merge-patch+json',
      })
      .pipe(map((response: ApiResponseModel) => new PortOvertimeRuleModel().fromJSON(this.extractObject(response.data))));
  }

  public replace(ruleId: string, payload: Partial<PortOvertimeRuleModel>): Observable<PortOvertimeRuleModel> {
    return this.apiService
      .updateObj(environment.API.PORT_OVERTIME_RULES_URI, ruleId, payload)
      .pipe(map((response: ApiResponseModel) => new PortOvertimeRuleModel().fromJSON(this.extractObject(response.data))));
  }

  public remove(ruleId: string): Observable<boolean> {
    return this.apiService.deleteObj(environment.API.PORT_OVERTIME_RULES_URI, ruleId);
  }

  private portIri(portId: string): string {
    return `/api/ports/${portId}`;
  }

  private extractObject(data: any): any {
    if (data && typeof data === 'object' && 'data' in data) {
      return data.data;
    }

    return data;
  }

  private extractCollection(data: any): any[] {
    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.items)) {
      return data.items;
    }

    if (Array.isArray(data?.data)) {
      return data.data;
    }

    if (Array.isArray(data?.['hydra:member'])) {
      return data['hydra:member'];
    }

    return [];
  }
}
